import styled, { keyframes } from 'styled-components'
import { GlobalColorEnum } from '@/constants/global-color.enum'

export const Skeleton = () => (
  <>
    <SkeletonBase width={'38%'} />
    <StyledWriteSkeletonInnerDiv>
      <SkeletonBase width={'100%'} />
      <SkeletonBase width={'100%'} />
      <SkeletonBase width={'60%'} />
    </StyledWriteSkeletonInnerDiv>
  </>
)

interface SkeletonBaseProps {
  width: number | `${number}rem` | `${number}%`
}

/**
 * antd 대체를 위해 생성한 Base Skeleton 컴포넌트
 */
export const SkeletonBase = ({ width }: SkeletonBaseProps) => {
  return <StyledSkeletonDiv width={width} />
}

const shineLines = keyframes`
  0% {
    background-position: 100%;
  }
  75% {
    background-position: -100%;
  }
  100% {
    background-position: -100%;
  }
`

const StyledSkeletonDiv = styled.div<Pick<SkeletonBaseProps, 'width'>>`
  width: ${({ width }) => {
    if (typeof width === 'string') {
      return width
    }
    return `${width}rem`
  }};
  height: 1.4rem;
  min-height: 1.4rem;
  border-radius: 0.4em;
  background-image: linear-gradient(
    90deg,
    ${GlobalColorEnum.Gray50} 0rem,
    ${GlobalColorEnum.Gray100} 12rem,
    ${GlobalColorEnum.Gray50} 24rem
  );
  background-size: 200% 100%;
  animation: ${shineLines} 1.4s infinite ease;
`

const StyledWriteSkeletonInnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 2rem;
`
